import PasswordField from "@/components/Common/forms/PasswordField";
import useRegistrationStore from "@/store/registration";
import {type FC} from "react";
import {useTranslation} from "react-i18next";

const RegistrationPasswordField: FC<{className?: string; labelClassName?: string}> = ({className, labelClassName}) => {
  const {t} = useTranslation("common");
  const errorMessage = useRegistrationStore(state => state.errors["password"]);
  const setValue = useRegistrationStore(state => state.setValue);
  const valueFromStore = useRegistrationStore(state => state["password"]);

  return (
    <PasswordField
      className={className}
      onChange={value => setValue("password", value)}
      error={t(errorMessage as "passwordAtLeast8Charaters")}
      value={valueFromStore}
      label={t("Password")}
      labelClassName={labelClassName}
      placeholder={t("Password")}
      customFieldId="registration-password-field"
      dataTestId="registration-password-field"
    />
  );
};

export default RegistrationPasswordField;
